import React from "react";
import "../App.css";
function Footer() {
 
  return (
    <>
    <div
        className="sectionheader"
        style={{ backgroundColor: "rgb(76, 149, 197)" }}
      >
        <hr />
        <h1 style={{ color: "white" }}>
          <span style={{ color: "red" }}>&#10084;</span> Prateek Bajpai
        </h1>
        <hr />
      </div>
      <div
        style={{
          textAlign: "center",
          fontSize: "1.1rem",
          paddingBottom: "1rem",
          backgroundColor: "rgb(76, 149, 197)",
          color: "white",
        }}
      >
        &#169; Prateek Bajpai. All rights reserved.
      </div>
    </>
  );
}
export default Footer;
